import { action } from 'satcheljs';
export default action('SET_OPTIONS_SEARCH_TERM', function (query) { return ({ query: query }); });
//# sourceMappingURL=setSearchTerm.js.map